module.exports = __webpack_public_path__ + "public/images/program/program-2.ed15505d1ea306eab5dda1410d899500.png";